import { useEffect } from "react";

const PUB = process.env.REACT_APP_PUBLIC_URL || "";

export function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title;
    const upsert = (selector, tag, attrs) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement(tag);
        document.head.appendChild(el);
      }
      Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    };
    upsert('meta[name="description"]', "meta", { name: "description", content: description });
    upsert('meta[property="og:title"]', "meta", { property: "og:title", content: title });
    upsert('meta[property="og:description"]', "meta", { property: "og:description", content: description });
    upsert('meta[property="og:url"]', "meta", { property: "og:url", content: PUB + window.location.pathname });
    upsert('link[rel="canonical"]', "link", { rel: "canonical", href: PUB + window.location.pathname });
  }, [title, description]);
}

export function trackVisit(path) {
  try {
    let sid = sessionStorage.getItem("ccc_sid");
    if (!sid) {
      sid = crypto.randomUUID ? crypto.randomUUID() : String(Math.random()) + Date.now();
      sessionStorage.setItem("ccc_sid", sid);
    }
    const payload = JSON.stringify({
      path,
      referrer: document.referrer || "",
      utm: window.location.search || "",
      device: window.innerWidth < 768 ? "mobile" : "desktop",
      session_id: sid,
    });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${process.env.REACT_APP_BACKEND_URL || ""}/api/track`, new Blob([payload], { type: "application/json" }));
    } else {
      fetch(`${process.env.REACT_APP_BACKEND_URL || ""}/api/track`, { method: "POST", headers: { "Content-Type": "application/json" }, body: payload, keepalive: true }).catch(() => {});
    }
  } catch {}
}
